import script from "./redGold.vue?vue&type=script&setup=true&lang=js"
export * from "./redGold.vue?vue&type=script&setup=true&lang=js"

import "./redGold.vue?vue&type=style&index=0&id=05a4208c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05a4208c"]])

export default __exports__